export default "__VITE_ASSET__UR2omrMF__"